import { Component, Input } from '@angular/core';

@Component({
  selector: 'avano-more-less-information',
  templateUrl: './avano-more-less-information.component.html',
  styleUrls: ['./avano-more-less-information.component.scss']
})
export class AvanoMoreLessInformationComponent {
  @Input() headerText: string;
  @Input() collapsed = true;
}
